var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chargement",style:('transition: width '+_vm.duree+'s ease;width:'+_vm.width+'%')})}
var staticRenderFns = []

export { render, staticRenderFns }